const mobile_nav = function() {
    //alert("mobile_nav ready");
    const burger = document.querySelector('.hamburger');
    const menu = document.querySelector('.menu-mobile');
    if (burger) {
        burger.addEventListener('click', () => {
            burger.classList.toggle('hamburger--open');
            if (menu) {
                menu.classList.toggle('menu-mobile--open');
            }
        });
    }
};

export {mobile_nav};
